import { Routes, Route } from 'react-router-dom';
import { CompanyFilterProvider } from './contexts/CompanyFilterContext';
import { VeevaReconcileLayout } from './components/VeevaReconcileLayout';
import { Dashboard } from './components/Dashboard';
import { IssuesWorkspace } from './components/issues/IssuesWorkspace';
import { TransactionsExplorer } from './components/TransactionsExplorer';
import { ApprovalsQueue } from './components/ApprovalsQueue';
import { AuditLog } from './components/AuditLog';

export default function VeevaReconcileApp() {
  return (
    <CompanyFilterProvider>
      <Routes>
        <Route element={<VeevaReconcileLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="issues" element={<IssuesWorkspace />} />
          <Route path="transactions" element={<TransactionsExplorer />} />
          <Route path="approvals" element={<ApprovalsQueue />} />
          <Route path="audit" element={<AuditLog />} />
        </Route>
      </Routes>
    </CompanyFilterProvider>
  );
}
